import { Injectable } from '@angular/core';

import { Category } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CategoryService extends TmsWebBaseEditService<Category, Category> {
  constructor() {
    super('Category', $localize`Category`);
  }
}
